import {createContext, useContext, useEffect, useState} from 'react'

const PageDataContext = createContext({
  setPageTitle: (_title) => {},
  setPageBreadcrumbs: (_breadcrumbs) => {},
  setPageMenu: (_menu) => {},
  setPageDescription: (_description) => {},
})

const PageDataProvider = ({children}) => {
  const [pageTitle, setPageTitle] = useState('')
  const [pageDescription, setPageDescription] = useState('')
  const [pageBreadcrumbs, setPageBreadcrumbs] = useState([])
  const [pageMenu, setPageMenu] = useState([])
  const value = {
    pageTitle,
    setPageTitle,
    pageDescription,
    setPageDescription,
    pageBreadcrumbs,
    setPageBreadcrumbs,
    pageMenu,
    setPageMenu,
  }
  return <PageDataContext.Provider value={value}>{children}</PageDataContext.Provider>
}

function usePageData() {
  return useContext(PageDataContext)
}

const PageTitle = ({children, description = '', breadcrumbs, menu}) => {
  const {setPageTitle, setPageDescription, setPageBreadcrumbs, setPageMenu} = usePageData()

  useEffect(() => {
    if (children) setPageTitle(children.toString())
    return () => setPageTitle('')
  }, [children])

  useEffect(() => {
    if (description) setPageDescription(description)
    return () => setPageDescription('')
  }, [description])

  useEffect(() => {
    if (breadcrumbs) setPageBreadcrumbs(breadcrumbs)
    return () => setPageBreadcrumbs([])
  }, [breadcrumbs])

  useEffect(() => {
    if (menu) setPageMenu(menu)
    return () => setPageMenu([])
  }, [menu])

  return <></>
}

const PageDescription = ({children}) => {
  const {setPageDescription} = usePageData()

  useEffect(() => {
    if (children) setPageDescription(children.toString())
    return () => setPageDescription('')
  }, [children])

  return <></>
}

export {PageDescription, PageTitle, PageDataProvider, usePageData}
